<template>
  <div class="s-order">
    <div class="s-clock-header">
      <div class="header-tabs">
        <div
          class="tabs"
          :class="{ active: mainIndex == item.id }"
          v-for="(item, i) in mainType"
          :key="i"
          @click="changetabs(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="close iconfont icon-close-line" @click="() => { $emit('hide');}"></div>
    </div>
    <s-order-have v-show="mainIndex==2"></s-order-have>
  </div>
</template>
<script>
import sOrderHave from './s-order-have.vue';
export default {
  components: {sOrderHave},
  name: "",
  props: {},
  data() {
    return {
      mainType: [
        { id: 1, name: "门票预订" },
        { id: 2, name: "我预订的" },
      ],
      mainIndex: 2,
    };
  },
  mounted() {},
  computed: {},
  methods: {
      changetabs(e){
          this.mainIndex = e;
      }
  },
};
</script>
<style scoped lang="scss">
.s-order {
  background: #fff url(../../assets/images/bg2.png) center top no-repeat;
  background-size: 105%;
  padding: 0 15rem 40rem;
  max-width: var(--maxWidth);
  min-height: 300rem;
  margin: 0 auto;
  border-radius: 20rem 20rem 0 0;
}
.s-clock-header {
  position: relative;
  width: 100%;
  height: 60rem;
  line-height: 60rem;
  border-bottom: 1rem solid #ddd;
  box-sizing: border-box;
  .close {
    font-size: 24rem;
    color: var(--fontGray);
    position: absolute;
    right: 10rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .header-tabs {
      display: flex;
    .tabs {
      font-size: 16rem;
      color: #666666;
      margin-right: 40rem;
      transition: all 0.5s;
      &.active {
        color: #ff6200;
        font-weight: 500;
      }
      &:last-child {
          margin-right: 0;
      }
    }
  }
}
</style>
